export const MEDIA_CATALOG_LOAD = 'MEDIA_CATALOG_LOAD';
export const MEDIA_CATALOG_ERROR = 'MEDIA_CATALOG_ERROR';
